import Select from 'react-select'
import { ISelectData } from '../Selects/select/model'
import { useTranslation } from 'react-i18next'
import makeAnimated from 'react-select/animated'
import { FC, useEffect, useState } from 'react'
import { useGetSchoolQuery } from '../../store/api/school/school.api'
import { selectedDataTake } from '../../utils/selectedDataTake/selectedDataTake'
import { Col } from 'react-bootstrap'
import { IFilterProps } from '../../global.model'

const animatedComponents = makeAnimated()

const FilterBySchool: FC<IFilterProps> = ({ query, setQuery }): JSX.Element => {
  const { t: tGeneral } = useTranslation('general')
  const { data: schools } = useGetSchoolQuery()
  const [schoolSelected, setSchoolSelectedData] = useState<ISelectData[]>([])

  const handleChange = (value: number, name: string): void => {
    query.set(name, value.toString())
    const page = query.get('page')
    if (page !== '1') {
      query.set('page', '1')
    }
    setQuery(query)
  }

  useEffect(() => {
    selectedDataTake(schools, setSchoolSelectedData)
  }, [schools])

  return (
    <Col md={6} lg={4} xl={2}>
      <Select
        onChange={selectedOptions =>
          handleChange((selectedOptions as ISelectData).value, 'schoolId')
        }
        options={schoolSelected}
        components={animatedComponents}
        name='schoolId'
        placeholder={tGeneral('school')}
        value={schoolSelected.find(option => option.value === Number(query?.get('schoolId'))) || ''}
      />
    </Col>
  )
}

export default FilterBySchool
